import { NetworkType } from "utils/network";
import { getMerchant } from "utils/AxiosUtil";

// One definition of the merchant-info query. networkType is IN the key: merchantName is unique
// only within a network (one contract per deployment), so a shared key would serve testnet's name
// for a mainnet id and never revalidate under staleTime Infinity.
export function merchantInfoQuery(
  merchantId: string,
  networkType: NetworkType,
) {
  return {
    queryKey: ["merchantInfo", merchantId, networkType] as const,
    queryFn: async () => {
      const res = await getMerchant(merchantId, networkType);
      return res.data;
    },
  };
}
